import React from "react";
import { ResponsiveLayout } from "../ResponsiveLayout";
import { SizedBox } from "../SizedBox";
import { StoreButtonsBlock } from "../StoreButtonsBlock";
import { translation } from "../translations";
import { Header3 } from "../typography";
import { SlantedSection } from "./SlantedSection";

export const DownloadSection: React.FC = () => (
  <SlantedSection
    justifyContent="right"
    gradient
    offset={-700}
    height={229}
    width={2000}
  >
    <ResponsiveLayout justifyContent="center" alignItems="center">
      <Header3 color="white" center>
        {translation.downloadForFree}
      </Header3>

      <SizedBox desktopWidth={200} mobileHeight={8} />

      <StoreButtonsBlock
        forceVerticalLayout={true}
        showStoreButtonsCallToAction={false}
      />

      <SizedBox desktopWidth={140} />
    </ResponsiveLayout>
  </SlantedSection>
);
